import { gql } from '@apollo/client';

export const UPDATE_INCIDENT_NARRATIVE_CONFIDENTIAL = gql`
  mutation addOrUpdateIncidentNarrative($input: AddOrUpdateIncidentNarrativeInput!) {
    addOrUpdateIncidentNarrative(input: $input) {
      errors
      incidentNarrative {
        id
        confidential
      }
      timestamp
      incidentNarrativeUuid
      incidentUuid
    }
  }
`

export const UPDATE_INCIDENT_NARRATIVE_TYPE = gql`
  mutation addOrUpdateIncidentNarrative($input: AddOrUpdateIncidentNarrativeInput!) {
    addOrUpdateIncidentNarrative(input: $input) {
      errors
      incidentNarrative {
        id
        incidentNarrativeType {
          id
          name
          oriId
        }
      }
      timestamp
      incidentNarrativeUuid
      incidentUuid
    }
  }
`
export const UPDATE_INCIDENT_NARRATIVE = gql`
  mutation addOrUpdateIncidentNarrative($input: AddOrUpdateIncidentNarrativeInput!) {
    addOrUpdateIncidentNarrative(input: $input) {
      errors
      incidentNarrative {
        confidential
        employee {
          id
          deptAttribute {
            badge
              ori {
              id
              oriName
              abbreviation
            }
          }
          personalAttribute {
            firstName
            lastName
          }
        }
        id
        incidentNarrativeType {
          id
          name
          oriId
        }
        narrative
        timestamp
      }
      incidentNarrativeUuid
      incidentUuid
    }
  }
`
export const ADD_OR_UPDATE_INCIDENT_NARRATIVE = gql`
  mutation addOrUpdateIncidentNarrative($input: AddOrUpdateIncidentNarrativeInput!) {
    addOrUpdateIncidentNarrative(input: $input) {
      errors
      incidentNarrative {
        confidential
        employee {
          id
          deptAttribute {
            badge
              ori {
              id
              oriName
              abbreviation
            }
          }
          personalAttribute {
            firstName
            lastName
          }
        }
        id
        incidentNarrativeType {
          id
          name
          oriId
        }
        narrative
        timestamp
      }
      incidentNarrativeUuid
      incidentUuid
    }
  }
`